import React from 'react';
import "../Figure.css"


function Figure4() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Blanks (no Cd added) </th>
              <th>Cd concentration</th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Water </th>
              <td> 0 mg/L </td>
          </tr>           
          <tr>
              <th> EC20 </th>
              <td> 0 mg/L </td>
          </tr> 
          <tr>
              <th> SpaC </th>
              <td> 0 mg/L </td>
          </tr> 
          </tbody>
        </table>
    </div>
  );
}

export default Figure4;